module.exports = __webpack_public_path__ + "static/Burst_5-b7f85e0dd3dcaa265de2079e577ac047.jpg";